import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../layouts/Modal";
import LoadingWheel from "../shared/LoadingWheel";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { IPart } from "../../models/Part";
import useShipping from "../../data/useShipping";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

interface TrackingInfoModalProps {
  isOpen: boolean;
  onClose: () => void;

  part: IPart;

  customLoading: boolean;
  setCustomLoading: any;

  setPinModalOpen: any;
  setPinState: any;
}

export default function TrackingInfoModal({ isOpen, onClose, part, customLoading, setCustomLoading, setPinModalOpen, setPinState }: TrackingInfoModalProps) {
  const { t } = useTranslation("stock");
  const { customShipping } = useShipping(part);
  const { saveHandlers } = useDefaultCRUDHandlers("Shipping");

  const [customTrackingNum     , setCustomTrackingNum    ] = useState("");
  const [customTrackingCarrier , setCustomTrackingCarrier] = useState("FedEx");

  const sendCustomShipping = () => {
    setCustomLoading(true);

    setPinModalOpen(true);
    setPinState({
      onPinSuccess: () => {
        customShipping.mutate(
          {
            partDataId: part.id,
            trackingNumber: customTrackingNum,
            carrier: customTrackingCarrier,
          },
          {
            onSuccess: () => {
              saveHandlers.onSuccess();
              onClose();
            },
            onError: (res: any) => {
              saveHandlers.onError();
            },
            onSettled: () => {
              setCustomLoading(false);
            },
          }
        );
      },
      onPinFailed: () => { },
      pinLabel: t("Submit Tracking Information"),
    });
  };

  const modalContent = (
    <>
      <div className="flex flex-col gap-4 mb-2">
        <div>
          <label className="text-lg font-bold">
            {t("Tracking Number")}:{" "}
          </label>
          <input
            type="text"
            value={customTrackingNum}
            onChange={(x) => setCustomTrackingNum(x.target.value)}
          />
        </div>
        <div>
          <label className="text-lg font-bold">
            {t("Shipping Carrier")}:{" "}
          </label>
          <select
            value={customTrackingCarrier}
            onChange={(x) => setCustomTrackingCarrier(x.target.value)}
          >
            <option value={"FedEx"}>Fedex</option>
            <option value={"RoyalMail"}>Royal Mail</option>
            <option value={"Other"}>{t("Other")}</option>
          </select>
        </div>
      </div>
      <div className="float-right">
        <ButtonInput
          label={t("Submit Tracking Infomation")}
          isSubmit={false}
          onClick={() => sendCustomShipping()}
          classes={"mr-2"}
          disabled={customTrackingNum.length < 5}
        />
      </div>
    </>
  );

  return(
    <Modal
      open={isOpen}
      setOpen={onClose}
      width="max-w-4xl mx-4"
    >
      <div>
        <div className="mb-4">
          <p className="text-lg font-bold mb-2">{t("Custom Tracking Details")}</p>

          {customLoading ? <LoadingWheel /> : modalContent}

        </div>
      </div>
    </Modal>
  );
}